import React from 'react';
import { useAuth } from '../context/AuthContext';
import './Admin.css';

const AdminLOAs = () => {
  const { user } = useAuth();

  const exampleLOAs = [
    {
      id: 1,
      customerName: user?.fullName || user?.username || 'You',
      contactEmail: user?.email || 'you@example.com',
      siteAddress: '123 Main St, Indianapolis, IN',
      status: 'Approved',
      requestedDate: '2025-01-15',
      isYou: true
    },
    {
      id: 2,
      customerName: 'Acme Corp',
      contactEmail: 'facilities@acme.example.com',
      siteAddress: '456 Business Park Dr, Suite 200',
      status: 'Pending',
      requestedDate: '2025-02-01',
      isYou: false
    },
    {
      id: 3,
      customerName: 'TechStart LLC',
      contactEmail: 'admin@techstart.example.com',
      siteAddress: '789 Innovation Way',
      status: 'Draft',
      requestedDate: '2025-02-05',
      isYou: false
    }
  ];

  const statusClass = (status) => {
    const s = (status || '').toLowerCase();
    if (s === 'approved') return 'admin-sub-active';
    if (s === 'pending') return 'admin-sub-pastdue';
    return 'admin-sub-none';
  };

  return (
    <div className="admin-card">
      <h1 className="admin-title">LOAs</h1>
      <p className="admin-subtitle">Letters of Authorization — example view</p>

      <div className="admin-table-wrap">
        <table className="admin-table">
          <thead>
            <tr>
              <th>Customer</th>
              <th>Contact email</th>
              <th>Site / Address</th>
              <th>Status</th>
              <th>Requested</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {exampleLOAs.map((loa) => (
              <tr key={loa.id}>
                <td>
                  {loa.customerName}
                  {loa.isYou && <span className="admin-cell-you"> (you)</span>}
                </td>
                <td>{loa.contactEmail}</td>
                <td className="admin-cell-product">{loa.siteAddress}</td>
                <td>
                  <span className={`admin-sub-badge ${statusClass(loa.status)}`}>
                    {loa.status}
                  </span>
                </td>
                <td className="admin-cell-date">{loa.requestedDate}</td>
                <td>
                  <button type="button" className="admin-btn admin-btn-role" disabled>
                    View
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminLOAs;
